import { useStore } from 'zustand';
import { createStore } from 'zustand/vanilla';
import { createAuthSlice } from '../../../features/auth';
import { createNotificationSlice } from '../../../features/notifications';
import { createDelegationSlice } from '../../../entities/delegation';
import { createUserSlice } from '../../../entities/user';
import { AppStoreState, initialLoadingState } from './types';

export const appStore = createStore<AppStoreState>()((...args) => ({
  loading: initialLoadingState,
  ...createNotificationSlice(...args),
  ...createDelegationSlice(...args),
  ...createUserSlice(...args),
  ...createAuthSlice(...args),
}));

export function useAppStore<T>(selector: (state: AppStoreState) => T) {
  return useStore(appStore, selector);
}
